// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import PassportActionType from './passport-details.types';

const INITIAL_STATE = {
	updatePassportResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** Passport Update Start ************************/
		case PassportActionType.UPDATE_PASSPORT_SUCCESS:
			return { ...state, updatePassportResponse: action.payload };

		case PassportActionType.UPDATE_PASSPORT_FAILURE:
			return { ...state, updatePassportResponse: action.payload };

		case PassportActionType.UPDATE_PASSPORT_RESPONSE_CHANGED:
			return { ...state, updatePassportResponse: null };

		/** ***************** Passport Update End ************************/

		default:
			return state;
	}
};
